var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEndConvo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "78px",
    viewBox: "-4.8 -4.8 57.60 57.60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.8,
    width: 57.6,
    height: 57.6,
    rx: 28.8,
    fill: "#ff0000",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4356 21.8489C16.9956 26.88 21.12 30.9867 26.1511 33.5644L30.0622 29.6533C30.5422 29.1733 31.2533 29.0133 31.8756 29.2267C33.8667 29.8844 36.0178 30.24 38.2222 30.24C39.2 30.24 40 31.04 40 32.0178V38.2222C40 39.2 39.2 40 38.2222 40C21.5289 40 8 26.4711 8 9.77778C8 8.8 8.8 8 9.77778 8H16C16.9778 8 17.7778 8.8 17.7778 9.77778C17.7778 12 18.1333 14.1333 18.7911 16.1244C18.9867 16.7467 18.8444 17.44 18.3467 17.9378L14.4356 21.8489Z",
    fill: "#fafafa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndConvo);
export default __webpack_public_path__ + "static/media/end_convo.8f8b595635a15c9534330e8a788ff1f9.svg";
export { ForwardRef as ReactComponent };